(ns hypnos.consumer.panels.consult.deviated-septum
  "The consult deviated septum step."
  (:require [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; fields

(defn- navigation
  [state nav-fn]
  [:div.field.is-grouped
   [:p.control
    [:button.button.is-rounded.is-info
     {:on-click (fn [_] (nav-fn state :deviated-septum :next))}
     (tr :ui.label/next)]]
   [:p.control
    [:button.button.is-rounded.is-light
     {:on-click (fn [_] (nav-fn state :deviated-septum :prev))}
     (tr :ui.label/prev)]]])

(defn- statement
  [consult]
  [:article.message.is-info
   [:div.message-body
    [:p (tr :ui.survey.deviated-septum/statement (:consult/service-type consult))]]])

(defn deviated-septum-field
  [state]
  [:div.field.has-check ;; .is-horizontal
   [:div.field-label.is-normal
    [:label.label (str (tr :ui.survey.deviated-septum/question))]]
   [:div.field-body
    [:div.field ;; .is-grouped-multiline.is-grouped
     [:div.control
      [:label.b-radio.radio
       [:input.input {:type      :radio
                      :name      "deviated-septum"
                      :checked   (true? (get-in @state [:consult :consult/deviated-septum? :value]))
                      :on-change (fn [e]
                                   (let [old-value (get-in @state [:consult :consult/deviated-septum? :value])
                                         new-value (when (-> e .-target .-checked) true)
                                         changed?  (or (get-in @state [:consult :consult/deviated-septum? :dirty?])
                                                       (not= new-value old-value))]
                                     (swap! state assoc-in
                                            [:consult :consult/deviated-septum? :value]
                                            new-value)
                                     (swap! state assoc-in
                                            [:consult :consult/deviated-septum? :dirty?]
                                            changed?)))
                      :on-focus  (fn [_] (swap! state assoc-in
                                                [:consult :consult/deviated-septum? :touched?]
                                                true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.label/yes)]]]
     [:div.control
      [:label.b-radio.radio
       [:input.input {:type      :radio
                      :name      "deviated-septum"
                      :value     (false? (get-in @state [:consult :consult/deviated-septum? :value]))
                      :on-change (fn [e]
                                   (let [old-value (get-in @state [:consult :consult/deviated-septum? :value])
                                         new-value (when (-> e .-target .-checked) false)
                                         changed?  (or (get-in @state [:consult :consult/deviated-septum? :dirty?])
                                                       (not= new-value old-value))]
                                     (swap! state assoc-in
                                            [:consult :consult/deviated-septum? :value]
                                            new-value)
                                     (swap! state assoc-in
                                            [:consult :consult/deviated-septum? :dirty?]
                                            changed?)))
                      :on-focus  (fn [_] (swap! state assoc-in
                                                [:consult :consult/deviated-septum? :touched?]
                                                true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.label/no)]]]]]])

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; step

(defn step
  "The deviated septum step"
  [state nav-fn]
  (let [consult (rf/subscribe [:consumer/consult])]
   [:div.card-content
    ;; statement
    [statement @consult]
    ;; field
    [deviated-septum-field state]
    [:hr]
    ;; navigation
    [navigation state nav-fn]]))
